import React from 'react';

const services = [
  {
    title: 'Graphics Designing',
    icon: 'fas fa-paint-brush',
    description: 'Professional visual designs for political campaigns, posters, banners, and digital graphics that capture attention and convey your message effectively.',
    color: 'from-blue-500 to-purple-600'
  },
  {
    title: 'Video Editing',
    icon: 'fas fa-video',
    description: 'Expert video editing services for campaign videos, promotional content, and social media clips with professional transitions and effects.',
    color: 'from-green-500 to-teal-600'
  },
  {
    title: 'Social Media Management',
    icon: 'fas fa-share-alt',
    description: 'Complete social media strategy, content creation, scheduling, and engagement management across all major platforms.',
    color: 'from-pink-500 to-rose-600'
  },
  {
    title: 'Event Management',
    icon: 'fas fa-calendar-alt',
    description: 'End-to-end event planning and execution for rallies, conferences, and political gatherings with professional coordination.',
    color: 'from-yellow-500 to-orange-600'
  },
  {
    title: 'Twitter Engagement',
    icon: 'fab fa-twitter',
    description: 'Strategic Twitter campaigns, trend analysis, hashtag management, and real-time engagement to maximize your political reach.',
    color: 'from-cyan-500 to-blue-600'
  },
  {
    title: 'IVR Calls / Bulk SMS',
    icon: 'fas fa-phone-volume',
    description: 'Mass communication through automated voice calls and SMS campaigns to reach thousands of voters effectively.',
    color: 'from-indigo-500 to-purple-600'
  },
  {
    title: 'Short Films',
    icon: 'fas fa-film',
    description: 'Compelling short films and documentaries that tell your political story and connect with voters on an emotional level.',
    color: 'from-yellow-500 to-orange-600'
  },
  {
    title: 'Documentaries',
    icon: 'fas fa-file-video',
    description: 'Professional documentary production showcasing your achievements, vision, and impact on the community.',
    color: 'from-emerald-500 to-green-600'
  },
  {
    title: 'Ads',
    icon: 'fas fa-bullhorn',
    description: 'Creative advertising campaigns across digital and traditional media platforms to maximize your campaign visibility.',
    color: 'from-violet-500 to-purple-600'
  },
  {
    title: 'Campaigning',
    icon: 'fas fa-flag',
    description: 'Comprehensive campaign strategy, planning, and execution with data-driven approaches for maximum electoral success.',
    color: 'from-orange-500 to-red-600'
  },
  {
    title: 'Photography',
    icon: 'fas fa-camera',
    description: 'Professional photography services for events, portraits, and campaign documentation with high-quality results.',
    color: 'from-teal-500 to-cyan-600'
  },
  {
    title: 'Videography',
    icon: 'fas fa-video',
    description: 'Expert videography for events, speeches, and campaign activities with professional equipment and techniques.',
    color: 'from-lime-500 to-green-600'
  },
  {
    title: 'Cinematography',
    icon: 'fas fa-film',
    description: 'Cinematic video production with artistic direction, professional lighting, and storytelling techniques.',
    color: 'from-amber-500 to-yellow-600'
  },
  {
    title: 'Drone Operation',
    icon: 'fas fa-helicopter',
    description: 'Aerial photography and videography using professional drones for unique perspectives and comprehensive coverage.',
    color: 'from-sky-500 to-blue-600'
  },
  {
    title: 'Nukkad Natak',
    icon: 'fas fa-theater-masks',
    description: 'Street theater performances that engage communities and convey political messages through entertaining and impactful storytelling.',
    color: 'from-yellow-500 to-orange-600'
  },
  {
    title: 'Managers',
    icon: 'fas fa-user-tie',
    description: 'Experienced campaign managers and coordinators to oversee operations, strategy implementation, and team management.',
    color: 'from-teal-500 to-cyan-600'
  },
  {
    title: 'Reporters',
    icon: 'fas fa-newspaper',
    description: 'Professional journalists and reporters for media coverage, press releases, and news content creation.',
    color: 'from-neutral-500 to-stone-600'
  },
  {
    title: 'On-field Surveyors',
    icon: 'fas fa-map-marked-alt',
    description: 'Ground-level research and survey teams to gather voter insights, feedback, and constituency analysis.',
    color: 'from-emerald-500 to-teal-600'
  },
  {
    title: 'Voice-Overs',
    icon: 'fas fa-microphone-alt',
    description: 'Professional voice-over services for advertisements, announcements, and audio content in multiple languages.',
    color: 'from-rose-500 to-red-600'
  },
  {
    title: 'LED Vans',
    icon: 'fas fa-truck-moving',
    description: 'Mobile LED advertising vans for dynamic campaign promotion and message broadcasting across different locations.',
    color: 'from-blue-500 to-indigo-600'
  },
  {
    title: 'Software Development',
    icon: 'fas fa-code',
    description: 'Custom software solutions for campaign management, voter databases, and digital tools to streamline operations.',
    color: 'from-purple-500 to-violet-600'
  },
  {
    title: 'Web Development',
    icon: 'fas fa-laptop-code',
    description: 'Professional website development for political campaigns, candidate profiles, and interactive voter engagement platforms.',
    color: 'from-green-500 to-emerald-600'
  },
  {
    title: 'App Development',
    icon: 'fas fa-mobile-alt',
    description: 'Mobile application development for campaign management, voter outreach, and real-time communication with supporters.',
    color: 'from-cyan-500 to-teal-600'
  },
];

const Services = () => {
  // Function to handle WhatsApp click with service-specific message
  const handleWhatsAppClick = (serviceName) => {
    const message = `Hello! I'm interested in your *${serviceName}* services. Could you please provide more information about this service and how it can help with my political campaign requirements? I'd like to discuss pricing and implementation details.`;
    const encodedMessage = encodeURIComponent(message);
    const phoneNumber = "917725898440";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Error handling for devices without WhatsApp
    try {
      // Check if we're on mobile and WhatsApp is available
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (isMobile) {
        // Try WhatsApp app first, fallback to web
        const whatsappAppUrl = `whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`;
        window.location.href = whatsappAppUrl;

        // Fallback to web WhatsApp after a short delay
        setTimeout(() => {
          window.open(whatsappUrl, '_blank');
        }, 1000);
      } else {
        // Desktop - open web WhatsApp
        window.open(whatsappUrl, '_blank');
      }
    } catch (error) {
      // Fallback: copy message to clipboard and show alert
      if (navigator.clipboard) {
        navigator.clipboard.writeText(message).then(() => {
          alert('WhatsApp is not available. The message has been copied to your clipboard. Please paste it in WhatsApp manually.');
        }).catch(() => {
          alert(`WhatsApp is not available. Please contact us at +91 7725898440 with this message: ${message}`);
        });
      } else {
        alert(`WhatsApp is not available. Please contact us at +91 7725898440 with this message: ${message}`);
      }
    }
  };

  return (
    <div className="bg-gray-100 py-12 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl mt-2 font-extrabold text-gray-900 tracking-tight sm:text-5xl">
            Our Services
          </h2>
          <p className="mt-4 max-w-1xl mx-auto text-xl text-gray-500">
            In today's political landscape, your image is your most valuable asset. At Jet Digital Infotech, we don't just run campaigns; we build powerful political brands. We are a full-service political consultancy specializing in a wide range of services to give you a competitive edge.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="service-card-container h-64 perspective-1000"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-card relative w-full h-full transition-transform duration-700 transform-style-preserve-3d hover:rotate-y-180">
                {/* Front Face */}
                <div className="service-card-face service-card-front absolute inset-0 w-full h-full bg-white rounded-lg shadow-lg p-6 flex flex-col items-center justify-center text-center backface-hidden">
                  <i className={`${service.icon} text-4xl text-blue-600 mb-4 transition-all duration-300`}></i>
                  <h3 className="text-lg font-bold text-gray-900 transition-all duration-300">{service.title}</h3>
                  <div className="mt-4 text-sm text-gray-500 opacity-75">
                    Hover to learn more
                  </div>
                </div>

                {/* Back Face */}
                <div className={`service-card-face service-card-back absolute inset-0 w-full h-full bg-gradient-to-br ${service.color} rounded-lg shadow-lg p-6 flex flex-col justify-between text-center backface-hidden rotate-y-180`}>
                  <div className="flex-1 flex flex-col justify-center">
                    <i className={`${service.icon} text-3xl text-white mb-3 opacity-90`}></i>
                    <h3 className="text-lg font-bold text-white mb-3">{service.title}</h3>
                    <p className="text-sm text-white opacity-90 leading-relaxed">
                      {service.description}
                    </p>
                  </div>

                  {/* WhatsApp Button */}
                  <div className="mt-4">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleWhatsAppClick(service.title);
                      }}
                      className="whatsapp-btn bg-white bg-opacity-20 hover:bg-opacity-30 text-white border border-white border-opacity-30 hover:border-opacity-50 rounded-full px-4 py-2 text-sm font-medium transition-all duration-300 flex items-center justify-center space-x-2 mx-auto backdrop-blur-sm hover:scale-105"
                      aria-label={`Contact us about ${service.title} via WhatsApp`}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        className="w-4 h-4 fill-current"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
                      </svg>
                      <span>WhatsApp</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom CTA Section - Added from VisionMission */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="text-center">
          <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-green-600 rounded-3xl p-8 md:p-12 text-white relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <svg viewBox="0 0 400 200" className="w-full h-full">
                <circle cx="100" cy="50" r="30" fill="none" stroke="currentColor" strokeWidth="1"/>
                <circle cx="300" cy="150" r="40" fill="none" stroke="currentColor" strokeWidth="1"/>
                <circle cx="200" cy="100" r="20" fill="none" stroke="currentColor" strokeWidth="1"/>
                <line x1="100" y1="50" x2="200" y2="100" stroke="currentColor" strokeWidth="0.5"/>
                <line x1="200" y1="100" x2="300" y2="150" stroke="currentColor" strokeWidth="0.5"/>
              </svg>
            </div>

            <div className="relative z-10">
              <h3 className="text-2xl md:text-3xl font-bold mb-4">
                Ready to Transform Your Political Campaign?
              </h3>
              <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
                Connect with our strategy experts and discover how our vision-driven approach can elevate your campaign to new heights.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a
                  href="tel:+917725898440"
                  className="bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-colors shadow-lg flex items-center space-x-2"
                >
                  <span>📞</span>
                  <span>: +91 77258 98440</span>
                </a>
                <a
                  href="mailto:contact@jetdigital.in"
                  className="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-blue-600 transition-colors flex items-center space-x-2"
                >
                  <span>✉️</span>
                  <span>contact@jetdigital.in</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .service-card-container {
          perspective: 1000px;
        }

        .service-card {
          transform-style: preserve-3d;
          transition: transform 0.7s cubic-bezier(0.4, 0.0, 0.2, 1);
        }

        .service-card:hover {
          transform: rotateY(180deg);
        }

        .service-card-face {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        .service-card-front {
          transform: rotateY(0deg);
          transition: all 0.3s ease;
        }

        .service-card-back {
          transform: rotateY(180deg);
        }

        .service-card-container:hover .service-card-front {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        }

        .service-card-container:hover .service-card-front i {
          transform: scale(1.1);
          color: #3b82f6;
        }

        .service-card-container:hover .service-card-front h3 {
          color: #1e40af;
        }

        .perspective-1000 {
          perspective: 1000px;
        }

        .transform-style-preserve-3d {
          transform-style: preserve-3d;
        }

        .backface-hidden {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        .rotate-y-180 {
          transform: rotateY(180deg);
        }

        .hover\\:rotate-y-180:hover {
          transform: rotateY(180deg);
        }

        /* Animation for cards appearing */
        .service-card-container {
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.6s ease forwards;
        }

        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Enhanced hover effects */
        .service-card-container:hover {
          transform: translateY(-5px);
        }

        .service-card-container {
          transition: transform 0.3s ease;
        }

        /* Smooth gradient transitions on back cards */
        .service-card-back {
          background-size: 200% 200%;
          animation: gradientShift 3s ease infinite;
        }

        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        /* WhatsApp Button Styles */
        .whatsapp-btn {
          box-shadow: 0 4px 12px rgba(255, 255, 255, 0.1);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .whatsapp-btn:hover {
          box-shadow: 0 6px 20px rgba(255, 255, 255, 0.2);
          transform: translateY(-2px) scale(1.05);
        }

        .whatsapp-btn:active {
          transform: translateY(0) scale(1.02);
        }

        /* Prevent card flip when clicking WhatsApp button */
        .whatsapp-btn {
          z-index: 10;
          position: relative;
        }
      `}</style>
    </div>
  );
};

export default Services;
